var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCharity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.534 28.175a13.212 13.212 0 1 1-26.424.002 13.212 13.212 0 0 1 26.424-.002",
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M39.093 35.824A13.215 13.215 0 0 1 15.7 32.093a9.3 9.3 0 0 1 3.702 1.011 5.85 5.85 0 0 0 2.675.657h3.312a4.29 4.29 0 0 1 4.273 4.562l7.368-2.34a4.55 4.55 0 0 1 2.064-.16",
    fill: "url(#paint0_linear_9129_76737)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M40.833 23.923a9.3 9.3 0 0 1-4.235-1.027 5.85 5.85 0 0 0-2.675-.657H30.61a4.286 4.286 0 0 1-4.274-4.562l-7.368 2.341c-.39.122-.795.192-1.203.206a13.217 13.217 0 0 1 23.069 3.694z",
    fill: "url(#paint1_linear_9129_76737)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.377 32.287-.049-.195.638-.155q.022.092.047.185zM12.101 31a18 18 0 0 1-.101-.662l.656-.085c.028.21.06.425.096.635zm-.21-1.772a15 15 0 0 1-.028-.67l.657-.015c0 .219.014.429.027.643zm.64-1.757-.657-.028c.01-.219.025-.447.044-.667l.656.054q-.03.321-.043.641m.167-1.705-.65-.098q.052-.33.11-.657l.644.126c-.035.206-.072.42-.104.63m.35-1.676-.633-.17c.056-.218.119-.429.184-.642l.627.195q-.096.308-.178.617m.531-1.628-.611-.238q.12-.31.255-.619l.601.263q-.128.295-.245.594m.706-1.56-.582-.304q.154-.297.32-.587l.57.328c-.106.183-.21.373-.308.562",
    fill: "#A9AFC4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.322 41.715a13.54 13.54 0 1 1 13.54-13.54 13.555 13.555 0 0 1-13.54 13.54m0-26.424a12.885 12.885 0 1 0 12.884 12.885A12.9 12.9 0 0 0 28.322 15.29",
    fill: "#5E6175"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.388 40.628a2.59 2.59 0 0 0 0-5.179h-3.313a7.5 7.5 0 0 1-3.452-.839 7.52 7.52 0 0 0-7.187.154l-1.4.802v8.917l10.636 3.345a8.3 8.3 0 0 0 4.969-.11l13.665-4.69a2.858 2.858 0 0 0-1.764-5.435l-9.188 2.917a2.6 2.6 0 0 1-.772.118z",
    fill: "#DEE1EC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.582 48.142 9.707 44.723v-9.348l1.566-.896a7.82 7.82 0 0 1 7.501-.16c1.021.525 2.153.8 3.301.801h3.313a2.917 2.917 0 0 1 1.846 5.18c.39 0 .645.016 1.026-.104l9.188-2.917a3.186 3.186 0 0 1 1.969 6.06l-13.661 4.693a8.6 8.6 0 0 1-5.174.11m-10.219-3.9 10.41 3.273a7.94 7.94 0 0 0 4.766-.104L39.2 42.717a2.53 2.53 0 0 0-1.56-4.812l-9.187 2.917a2.9 2.9 0 0 1-.875.133h-8.23V40.3h6.04a2.262 2.262 0 0 0 0-4.523h-3.313a7.9 7.9 0 0 1-3.602-.875 7.16 7.16 0 0 0-6.874.148l-1.236.707z",
    fill: "#5E6175"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.46 33.346v12.97H3.938v-12.97z",
    fill: "#2C9424"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.198 37.278a1.12 1.12 0 1 0 0-2.24 1.12 1.12 0 0 0 0 2.24",
    fill: "#F5F5F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.612 15.373a2.59 2.59 0 0 0 0 5.18h3.313c1.2 0 2.385.287 3.452.838a7.52 7.52 0 0 0 7.187-.154l1.4-.802v-8.917L35.329 8.173a8.3 8.3 0 0 0-4.969.11l-13.665 4.69a2.858 2.858 0 0 0 1.764 5.435l9.188-2.917c.25-.077.51-.117.77-.118z",
    fill: "#DEE1EC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.224 21.682a7.24 7.24 0 0 0-3.301-.802H30.61a2.917 2.917 0 0 1-1.846-5.18c-.386 0-.643-.015-1.026.104L18.55 18.72a3.186 3.186 0 0 1-1.968-6.06l13.66-4.693a8.6 8.6 0 0 1 5.168-.11l10.876 3.42v9.348l-1.567.896a7.82 7.82 0 0 1-7.495.16M30.61 15.7a2.262 2.262 0 0 0 0 4.523h3.313a7.9 7.9 0 0 1 3.602.875 7.16 7.16 0 0 0 6.88-.148l1.235-.707v-8.486L35.226 8.485a7.94 7.94 0 0 0-4.767.11L16.8 13.283a2.53 2.53 0 0 0 1.559 4.812l9.187-2.917a3 3 0 0 1 .87-.133h8.235v.656z",
    fill: "#5E6175"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.54 22.654V9.684h6.523v12.97z",
    fill: "#2C9424"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.822 20.346a1.12 1.12 0 1 0-1.99-1.033 1.12 1.12 0 0 0 1.99 1.033",
    fill: "#F5F5F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.832 28.789h3.703a4 4 0 0 1-.504.656c-.134.132-5.538 5.294-5.645 5.395l-5.343-4.98h2.508l1.466-1.47 2.108 2.108z",
    fill: "#2C9424"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.072 27.314h-4.85l-1.094 1.094-2.111-2.104-2.078 2.078h-3.052c-1.176-2.538.667-5.523 3.54-5.523a3.9 3.9 0 0 1 2.895 1.287 3.898 3.898 0 0 1 6.75 3.171z",
    fill: "#2C9424"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m42.602 43.996.464-.464 1.497 1.498-.464.464zm1.351-2.308h2.119v.656h-2.119zm-3.058 3.242h.656v2.12h-.657zM12.184 11.524l.464-.464 1.497 1.498-.464.464zm-1.496 2.684h2.118v.656h-2.118zm4.519-4.704h.656v2.119h-.656zm28.805 26.323a1.414 1.414 0 1 1 0-2.829 1.414 1.414 0 0 1 0 2.829m0-2.173a.758.758 0 1 0 .001 0m4.304-3.357a1.083 1.083 0 1 1 1.969-.321 1.085 1.085 0 0 1-1.969.321m.921-.995a.425.425 0 1 0 .413.524.426.426 0 0 0-.413-.52z",
    fill: "#5E6175"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9129_76737",
    x1: 15.699,
    y1: 36.74,
    x2: 39.093,
    y2: 36.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9129_76737",
    x1: 17.763,
    y1: 19.443,
    x2: 40.833,
    y2: 19.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharity);
export default __webpack_public_path__ + "static/media/charity.8ec4dbd52888208c9497c8c3e524786c.svg";
export { ForwardRef as ReactComponent };